export class UserAuditFilter {
    userId: number;
    startDate: Date;
    endDate: Date;

    constructor() {
        this.userId = 0;
        this.startDate = new Date();
        this.endDate = new Date();
    }
}
